export default __webpack_public_path__ + "static/media/call.8ca6ea30.mp4";